import Portal from "./Portal";
import { Modal } from "./Modal"
import FormViewerSkeleton from "../../skeleton_loaders/FormViewerSkeleton";
import FormViewer from "../form_editor/form_viewer";

export default function FormPreviewModal({loading, modalTitle, form, answers, onClose}) {
  return (
    <Portal
      component={Modal}
      size="lg"
      title={modalTitle}
      onClose={onClose}
      hideButtons
    >
      {loading ? <FormViewerSkeleton/> : <FormViewer form={form} answers={answers}/>}
    </Portal>
  );
}